<template>
    <div class="doc-header">
        <nav class="navbar navbar-inverse">
            <div class="doc-header-container">
                <div class="doc-header-navbar">
                    <a class="doc-header-navbar-logo" :href="smartProgram" target="_self">
                        <img :src="logo" alt="智能小程序">
                    </a>
                    <span class="doc-header-navbar-line"></span>
                    <a class="doc-header-navbar-des" :href="openSourceDocs" target="_self">
                        <img :src="docs" alt="开发者文档">
                    </a>
                </div>

                <div class="doc-header-topnav">
                    <ul>
                        <li v-for="item in docNavList" :key="item.link">
                            <a :href="origin + item.link">{{item.name}}</a>
                        </li>
                    </ul>
                </div>

                <!-- 搜索框 -->
                <search-bar class="doc-header-search-bar"
                    :source="searchSource"></search-bar>
            </div>
            <div class="doc-header-other">
                <a v-for="item in docNavOther"
                    :key="item.link"
                    :href="item.link"
                    target="_blank"
                    class="doc-header-other-item">
                    {{item.name}}
                </a>
            </div>
        </nav>
    </div>
</template>

<style lang="less">
    @import '../assets/less/components/doc-header.less';
</style>

<script>
import {mapState} from 'vuex';

export default {
    computed: {
        ...mapState({
            logo: state => state.header.logo,
            docs: state => state.header.docs,
            docNavList: state => state.header.docNavList,
            docNavOther: state => state.header.docNavOther,
            openSourceDocs: state => state.header.openSourceDocs,
            smartProgram: state => state.header.smartProgram,
            searchSource: state => state.header.searchSource[1]
        })
    }
};
</script>